import { fetchUtils } from "react-admin";
import {
  getAppContextHeaders,
  TokenProvider,
} from "../../app/app.context.provider";
import DescopeSdk from '@descope/web-js-sdk';

//descope: ReturnType<typeof descopeSdk>): AuthProvider => {
//export const descopeHttpClient = () => async (

export const descopeHttpClient = (descope: ReturnType<typeof DescopeSdk>) => {
  return async (url: string, options: fetchUtils.Options = {}) => {
    try {
      const token = (descope as any).getSessionToken();

      // Attempt to refresh the token if it's valid for less than 30 seconds
      const requestHeaders = getDescopeHeaders(url, token, options);

      // Proceed with the request
      return fetchUtils.fetchJson(url, {
        ...options,
        headers: requestHeaders,
      });
    } catch (error) {
      console.error("Failed to refresh token", error);
      // Handle token refresh failure, e.g., redirect to login
      // descope.refresh();
      return Promise.reject("Failed to refresh token");
    }
  };
};

/**
 * Return the headers needed by Descope.
 * @param token the Descope token
 * @param options the fetch options (so that we do not override other headers)
 * @returns the headers needed by Descope
 */
export const getDescopeHeaders = (
  url: string,
  token: string | null,
  options: fetchUtils.Options | undefined
): Headers => {
  const headers = ((options && options.headers) ||
    new Headers({
      Accept: "application/json",
    })) as Headers;
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  getAppContextHeaders(url, headers);
  return headers;
};

export const getTokenProvider = (descope: ReturnType<typeof DescopeSdk>): TokenProvider => {

  return {
    getIdToken: async () => {
      try {
        console.log("getIdToken");
        return (descope as any).getSessionToken();
      } catch (error) {
        console.error("Failed to refresh token", error);
        return null;
      }
    },
  };
};
